import React, { useState, useRef } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import FunctionsIcon from '@mui/icons-material/Functions';
import MathInsertDialog from './MathInsertDialog';

const TextFieldWithMath = ({
    value,
    onChange,
    label,
    multiline = false,
    rows = 1,
    disabled = false,
    required = false,
    helperText = '',
    ...otherProps
}) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [cursorPosition, setCursorPosition] = useState(null);
    const inputRef = useRef(null);

    const handleOpenDialog = () => {
        // Save current cursor position
        if (inputRef.current) {
            const input = inputRef.current.querySelector('textarea') || inputRef.current.querySelector('input');
            if (input) {
                setCursorPosition(input.selectionStart);
            }
        }
        setDialogOpen(true);
    };

    const handleInsertMath = (latex) => {
        if (!latex) return;

        const currentValue = value || '';
        let newValue;

        // Insert at cursor position if available
        if (cursorPosition !== null) {
            const before = currentValue.substring(0, cursorPosition);
            const after = currentValue.substring(cursorPosition);
            newValue = `${before}${latex}${after}`;
        } else {
            // Append at the end if no cursor position
            newValue = currentValue + latex;
        }

        onChange(newValue);
        setDialogOpen(false);
    };

    return (
        <>
            <TextField
                ref={inputRef}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                label={label}
                multiline={multiline}
                rows={rows}
                disabled={disabled}
                required={required}
                helperText={helperText}
                fullWidth
                variant="filled"
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={handleOpenDialog}
                                disabled={disabled}
                                edge="end"
                                title="Insert math expression"
                                size="small"
                            >
                                <FunctionsIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                {...otherProps}
            />
            <MathInsertDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onInsert={handleInsertMath}
            />
        </>
    );
};

export default TextFieldWithMath;
